import React, { useState, useEffect } from 'react'
import {
	CNav, CNavItem, CCard, CRow, CCol,
	CImage, CCardHeader, CCardTitle,
	CCardBody, CButton, CNavLink, CModal, CModalHeader, CModalBody,
	CModalFooter,
	CFormInput
} from 'compat/coreui';
import BusinessDashboard from './BusinessDashboard';
import BusinessMenu from './BusinessMenu';
import BusinessDeals from './BusinessDeals';
import ReviewSection from './ReviewSection';
import PhotosSections from './PhotosSections';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getData } from '../helpers/api';

export default function BusinessPage(props) {
	const token = localStorage.getItem('token');
	const [compCard, setCompCard] = useState('dashboard');
	const [bizId, setBizId] = useState('');
	const [sellerData, setSellerData] = useState({});
	const [follow, setFollow] = useState(true);
	const [modal, setModal] = useState(false);

	const location = useLocation();
	const dispatch = useDispatch();
	// const user = useSelector(state => state.user);

	const [cartData, setCartData] = useState([])
	const mytoken = localStorage.getItem('token');
	const orderDetails = localStorage.getItem('myProduct');

	let items = useSelector(state => state.products)

	useEffect(() => {
		const path = location.pathname.split('/')[2];
		setBizId(path);
		getBizDetails(path);
		getFollowers();
		if (orderDetails) {
			setCartData(JSON.parse(orderDetails))
		}

	}, [])
	const openModel = () => {
		console.log('---------------', modal);
		setModal(true)
		console.log('---------------', modal);
	}
	const submitNo = () => {
		window.location.replace("http://google.com/");
	}
	let totalPrice = 0
	if (items.length > 0) {
		items.map(item => {
			let p = item.productDetails[item.priceType]
			totalPrice = totalPrice + parseFloat(p) * item.quantity
		})
	}

	const placeOrder = (e) => {
		e.preventDefault();
		let cdata = cartData.slice().map(product => {
			product.productDetails = undefined
			return product
		});

		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/order`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + mytoken
			},
			data: {
				products: cdata
			}
		}).then(response => {
			if (response.data.status) {
				localStorage.removeItem('myProduct');
				setCartData([]);
				toast.success('Ordered successfully');
			}
		}).catch(console.log)
	}

	const removeItem = (id) => {
		let arr = [...items];
		arr.splice(id, 1);
		setCartData(arr);
		if (arr.length === 0) {
			dispatch({ type: 'UPDATE_PRODUCT', data: arr })
			localStorage.setItem('myproduct', '[]');
		} else {
			dispatch({ type: 'UPDATE_PRODUCT', data: arr })
			const newData = JSON.stringify(arr)
			localStorage.setItem('myProduct', newData);
		}
	}
	const goBack = () => {
		window.history.back();
	}

	const getFollowers = () => {
		getData(`${process.env.REACT_APP_APP_API_URL}/api/follow`).then(res => {
			if (res.data.status) {
				const path = location.pathname.split('/')[2];
				res.data.following.forEach(d => {
					let fid = d.following
					if (fid._id === path) {
						setFollow(false);
					}
				});
			}
		}).catch(console.log)
	}



	const getBizDetails = (path) => {
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/seller/${path}`,
			method: 'GET',
			headers: {
				'Authorization': 'Bearer ' + token
			},
		}).then(response => {
			if (response.data.status) {
				setSellerData(response.data.sellers[0]);
			}
		}).catch(console.log)
	}


	const followerHandler = () => {
		const data = {
			"seller": bizId
		}
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/follow`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + token
			},
			data,
		}).then(response => {
			if (response.data.status) {
				setFollow(false)
				toast.success('Followed successfully')
			}
		}).catch(console.log)
	}

	const unfollow = (id) => {
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/unfollow`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + token
			},
			data: { "seller": id }
		}).then(response => {
			if (response.data.status) {
				setFollow(true)
				toast.success('Unfollowed successfully')
			}
		}).catch(console.log)
	}
	return (
		<React.Fragment>
			<CModal
				show={modal}
			>
				<CModalHeader>Compose Message</CModalHeader>
				<CModalBody>
					<CCol className="text-center">
						<CCol>
							<CFormInput style={{ marginLeft: "10px", marginRight: "10px" }} placeholder="Enter a subject"></CFormInput>
							<CFormInput style={{ height: "100px", margin: "10px" }} placeholder="Enter a message"></CFormInput>
						</CCol>
						<CRow >
							<CButton style={{ background: "#FF5F1F", color: "white", width: "100%", marginLeft: "40px", marginRight: "40px" }} onClick={() => submitNo()}>NO</CButton>
						</CRow>
						<CCol>
							<h4>Joint Plug strives to abide by all state laws and regulations in regards to access to cannabis.</h4>
						</CCol>
					</CCol>
				</CModalBody>
			</CModal>
			<CRow className="m-0">
				<CCol lg={10}>
					<div className="business-info-section">
						<CCard className="business-info-card">
							<CCardHeader className="info-header">
								{sellerData.image ?
									<CImage src={'https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/' + sellerData.image} width="150" height="150" className="rounded-circle b-info-pic" />
									: <CImage src="/images/product-1.jpg" width="150" height="150" className="rounded-circle b-info-pic" />}
								<CCardTitle className="info-title">
									<div>
										<p>{sellerData.businessName}</p>
										<span>{sellerData.businessType}</span>
									</div>
									<div>
										<p>{sellerData.ownerPhone}</p>
										{follow ?
											(<><span>546</span><CButton color="warning" className="text-white ml-1" onClick={followerHandler}>FOLLOW</CButton></>) :
											(<><span>546</span><CButton color="warning" className="text-white ml-1" onClick={(e) => unfollow(sellerData._id)}>UNFOLLOW</CButton></>)
										}
									</div>
								</CCardTitle>
							</CCardHeader>
							<CCardBody className="mb-0 pb-0 custom_nav">
								<CNav variant="tabs" color="success">
									<CNavItem>
										<span class="fa fa-home icon"></span>
										<CNavLink active={compCard === 'dashboard'} onClick={() => setCompCard('dashboard')}>Dashboard</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-bars icon"></span>
										<CNavLink active={compCard === 'menu'} onClick={() => setCompCard('menu')}>Menu</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-delicious icon"></span>
										<CNavLink active={compCard === 'deals'} onClick={() => setCompCard('deals')}>Deals</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="icon-heart icon"></span>
										<CNavLink active={compCard === 'reviews'} onClick={() => setCompCard('reviews')}>Reviews</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-picture-o icon"></span>
										<CNavLink active={compCard === 'photos'} onClick={() => setCompCard('photos')}>Photos</CNavLink>
									</CNavItem>
									<CNavItem>
										<span class="fa fa-picture-o icon"></span>
										<CNavLink active={compCard === 'photos'} ><CImage src="/images/show_more.png"></CImage></CNavLink>
										<ul className="ul_list">
											<li><a href="#" class="about"><i class="fa fa-info-circle" aria-hidden="true"></i> About</a></li>
											<li onClick={() => openModel()} ><a class="contact"><i class="fa fa-envelope" aria-hidden="true"></i> Email Us</a></li>
											<li><a href="#" rel="nofollow" ><i class="fa fa-flag" aria-hidden="true"></i> Report</a></li>
											<li onClick={() => openModel()}><a class="contact" ><i class="fa fa-envelope" aria-hidden="true"></i> Message Business</a></li>
										</ul>
									</CNavItem>
									{/* <CNavItem>
								<CNavLink>:</CNavLink>
							  </CNavItem> */}
								</CNav>
							</CCardBody>
						</CCard>
						{compCard === "dashboard" && <BusinessDashboard seller={sellerData} />}
						{compCard === "menu" && <BusinessMenu seller={sellerData} />}
						{compCard === "deals" && <BusinessDeals seller={sellerData} />}
						{compCard === "reviews" && <ReviewSection seller={sellerData} />}
						{compCard === "photos" && <PhotosSections seller={sellerData} />}
					</div>
				</CCol>
				<CCol lg={2} className="cart-section">
					<div className="table-responsive cart-section-table">
						{(items.length > 0) ? <table style={{ width: '100%' }}>
							<thead>
								<tr>
									<th>Your Items</th>
								</tr>
							</thead>
							<tbody>
								{items.map((item, index) => {
									return (<tr key={index}>
										<td>
											<span style={{ width: '100%', color: 'green' }}>{item.productDetails !== undefined ? item.productDetails.name : ""}</span>
											<span className="price-type"> {item.quantity} </span>
											<span className="price-type">
												{item.priceType === "priceHalf" ? 'half'
													: item.priceType === "priceEight" ? 'eight'
														: item.priceType === "priceForth" ? 'forth'
															: item.priceType === "priceOz" ? 'oz'
																: "gram"
												}
											</span>
											<span className="price-type p-type">
												{item.quantity}x${item.priceType === "priceHalf" ? item.productDetails.priceHalf
													: item.priceType === "priceEight" ? item.productDetails.priceEight
														: item.priceType === "priceForth" ? item.productDetails.priceForth
															: item.priceType === "priceOz" ? item.productDetails.priceOz
																: item.productDetails.price
												}
											</span>
											<span onClick={() => removeItem(index)}><i className="fa fa-times-circle"></i></span>
										</td>

									</tr>)
								}
								)}
								<tr>
									<td className="pt-5"><span style={{ width: '90px' }}>SubTotal</span> <span>${totalPrice}</span></td>
								</tr>
								<tr>
									<td><span style={{ width: '90px' }}>Tax</span> <span>included</span></td>
								</tr>
								<tr>
									<td><span style={{ width: '90px' }}>Total</span> <span>${totalPrice}</span></td>
								</tr>
							</tbody>
						</table> :
							<table>
								<tbody>
									<tr>
										<td>
											Your cart is empty
                                </td>
									</tr>
								</tbody>
							</table>
						}
					</div>
					{(items.length > 0) && <CButton color="success" className="mt-5" onClick={placeOrder}>PLACE ORDER</CButton>}
					<CButton color="success" className="mt-5" style={{ marginLeft: "10px" }} onClick={goBack} >Add More</CButton>
				</CCol>
			</CRow>
		</React.Fragment>
	)
}